export default __webpack_public_path__ + "static/media/hyeonhoekim.78ab21b8.png";